const pagesNames = {
    home : {
        pageId : 1,
        name : "home",
    },
    environment : {
        name : "environment",
        pageId : 2,
    },
    statements : {
        name : "statements",
        pageId : 7,
    },
    journey : {
        name : "journey",
        pageId : 4,
    },
    starategy : {
        name : "strategy",
        pageId : 2,
    },
    news : {
        name : "news",
        pageId : 5,
    },
    insight : {
        name : "insight",
        pageId : 6,
    },
    commitments : {
        name : "commitments",
        pageId : 3,
    },
    resource : {
        name : "resource",
        pageId : 8,
    },
    transition : {
        name : "transition",
        pageId : 3,
    },
    saudiGreen : {
        name : "saudi-green",
        pageId : 3,
    },
    emissions : {
        name : "reducing-our-emissions",
        pageId : 3
    },
    vision : {
        name : "vision",
        pageId : 3,
    },
    social : {
        name : "social",
        pageId : 2,
    },
    governance : {
        name : "governance",
        pageId : 2,
    },
    sustainableFinancing : {
        name : "sustainable-financing",
        pageId : 3,
    },
    materials : {
        name : "materials-matters",
        pageId : 2,
    },
    esgProfile : {
        name : "ESG-Profile",
        pageId : 8,
    },
    singleNewsPost : {
        name : "single-news-post",
        pageId : 5,
    },
    singleInsightPost : {
        name : "single-insight-post",
        pageId : 6,
    },
    highlight : {
        name : "2022-ESG-Highlights",
        pageId : 4,
    },
    reports : {
        name : "Reports-and-Disclouser",
        pageId : 8,
    },
    compliance : {
        name : "compliance-with-regulations",
        pageId : 7,
    },
    csr : {
        name : "csr",
        pageId : 7,
    },
    risk : {
        name : "risk-mangment",
        pageId : 2,
    },
    embedding : {
        name : "embedding-esg-throughout-sab",
        pageId : 4,
    },
    frameworks : {
        name : "international-framworks",
        pageId : 4,
    },
    business : {
        name : "business-strategy",
        pageId : 2,
    },
    stakeholders : {
        name : "stakeholders",
        pageId : 4,
    },
}

export default pagesNames;